import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';
import { IDetailViewGroupDTO, IDVGItemDTO } from "coreframetypings/dto";
import RADApplication from '@/Management/RADApplication';
import MessageBoxViewModelType from '@/ViewModels/Controls/MessageBoxViewModel';
import ResourceManager from '@/Management/ResourceManager';
import DesignWizardViewModel from '@/ViewModels/Controls/DesignWizardViewModel';

export default class DesignWizardUIListener extends UIListener {

    private MessageBoxViewModel = ComponentManager.getViewModel<typeof MessageBoxViewModelType>('MessageBoxViewModel');

    constructor() {
        super();
    }

    public onBeforeRender(context: DetailViewContext): void {
        if (!this.isDetailViewContext(context)) {
            return;
        }

        let detailViewGroups = context.detailViewContextDTO.detailView.detailViewGroups;
        let groupIndex = _.findIndex(detailViewGroups, (group: IDetailViewGroupDTO) => {
            return group.ergName === 'RAD.RADFoundation.ProblemDomain.Meta.DesignWizard_DVG_APPLICATIONDESIGN';
        });
        if (groupIndex === -1) {
            return;
        }

        let detailViewGroup = detailViewGroups[groupIndex];
        let items = detailViewGroup.items;
        let itemIndex = _.findIndex(items, (item: IDVGItemDTO) => {
            return item.ergName === 'RAD.RADFOUNDATION.PROBLEMDOMAIN.META.DESIGNWIZARD_DEFINITION_ERGNAME';
        });
        if (itemIndex === -1) {
            return;
        }

        items.splice(itemIndex, 1);
    }

    public onAfterApply(context: DetailViewContext, isClosing: boolean): void {
        let templateStyle = RADApplication.getInstance().templateStyle();

        RADApplication.getInstance().templateStyle(templateStyle);
        let messageBox = this.MessageBoxViewModel.createNoticeMessageBox(ResourceManager.getInstance().get('DESIGN_WIZARD_STYLE_RELOAD_NOTICE'), null);
        RADApplication.getInstance().showMessageBox(messageBox, true);
    }

    public onBeforeCallOperation(context: DetailViewContext, operation: string): boolean {
        if (operation === 'Revert') {
            ((context.getUIFactory('DefinitionHTML') as ControlFactory).viewModel as DesignWizardViewModel).refresh(true);
            return false;
        }

        return true;
    }
}

ComponentManager.setUIListener('DesignWizardUIListener', DesignWizardUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.DesignWizardUIListener', DesignWizardUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');